import { computed, getCurrentInstance, reactive, ref } from '@vue/composition-api';

export const useAddFamily = () => {
  const vm = getCurrentInstance();
  const store =  vm.proxy.$store;
  const router = vm.proxy.$router;

  // getters
  const classId = computed({
    get: () => {
      return store.getters['addFamily/classId'];
    },
    set: (classId) => {
      store.commit('addFamily/SET_CLASS_ID', classId);
    }
  });
  const clientId = computed({
    get: () => {
      return store.getters['addFamily/clientId'];
    },
    set: (clientId) => {
      store.commit('addFamily/SET_CLIENT_ID', clientId);
    }
  });
  const contactInformation = computed(() => store.getters['addFamily/contactInformation']);
  const dob = computed({
    get: () => {
      return store.getters['addFamily/dob'];
    },
    set: (dob) => {
      store.commit('addFamily/SET_DOB', dob);
    }
  });
  const effectiveDate = computed({
    get: () => {
      return store.getters['addFamily/effectiveDate'];
    },
    set(effectiveDate) {
      store.commit('addFamily/SET_EFFECTIVE_DATE', effectiveDate);
    }
  });
  const eyemedId = computed(() => store.getters['addFamily/eyemedId']);
  const fileBoundId = computed({
    get: () => {
      return store.getters['addFamily/fileBoundId'];
    },
    set: (fileBoundId) => {
      store.commit('addFamily/SET_FILE_BOUND_ID', fileBoundId);
    }
  });
  const firstName = computed({
    get: () => {
      return store.getters['addFamily/firstName'];
    },
    set: (firstName) => {
      store.commit('addFamily/SET_FIRST_NAME', firstName);
    }
  });
  const fullName = computed(() => store.getters['addFamily/fullName']);
  const gender = computed({
    get: () => {
      return store.getters['addFamily/gender'];
    },
    set: (gender) => {
      store.commit('addFamily/SET_GENDER',gender);
    }
  });
  const groupCk = computed(() => store.getters['addFamily/groupCk']);
  const groupId = computed(() => store.getters['addFamily/groupId']);
  const groupName = computed(() => store.getters['addFamily/groupName']);
  const healthIdMatch = computed({
    get: () => {
      return store.getters['addFamily/healthIdMatch'];
    },
    set: (healthIdMatch) => {
      store.commit('addFamily/SET_HEALTH_ID_MATCH', healthIdMatch);
    }
  });
  const languageAssistance = computed(() => store.getters['addFamily/languageAssistance']);
  const lastName = computed({
    get: () => {
      return store.getters['addFamily/lastName'];
    },
    set: (lastName) => {
      store.commit('addFamily/SET_LAST_NAME', lastName);
    }
  });
  const memberCk = computed(() => store.getters['addFamily/memberCk']);
  const middleInitial = computed({
    get: () => {
      return store.getters['addFamily/middleInitial'];
    },
    set: (middleInitial) => {
      store.commit('addFamily/SET_MIDDLE_INITIAL', middleInitial);
    }
  });
  const planId = computed({
    get: () => {
      return store.getters['addFamily/planId'];
    },
    set: (planId) => {
      store.commit('addFamily/SET_PLAN_ID', planId);
    }
  });
  const privacyAddress = computed(() => store.getters['addFamily/privacyAddress']);
  const reportingCodes = computed(() => store.getters['addFamily/reportingCodes']);
  const transaction = computed(() => store.getters['addFamily/transaction']);
  const similarMembers = computed(() => store.getters['addFamily/similarMembers']);
  const ssn = computed({
    get: () => {
      return store.getters['addFamily/ssn'];
    },
    set: (ssn) => {
      store.commit('addFamily/SET_SSN', ssn);
    }
  });
  const ssnMatch = computed(() => store.getters['addFamily/ssnMatch']);
  const subGroupCk = computed(() => store.getters['addFamily/subGroupCk']);
  const subGroupId = computed(() => store.getters['addFamily/subGroupId']);
  const subGroupName = computed(() => store.getters['addFamily/subGroupName']);
  const subscriberCk = computed(() => store.getters['addFamily/subscriberCk']);
  const subscriberId = computed(() => store.getters['addFamily/subscriberId']);
  const suffix = computed({
    get: () => {
      return store.getters['addFamily/suffix'];
    },
    set: (suffix) => {
      store.commit('addFamily/SET_SUFFIX', suffix);
    }
  });
  const termDate = computed({
    get: () => {
      return store.getters['addFamily/termDate'];
    },
    set: (termDate) => {
      store.commit('addFamily/SET_TERM_DATE', termDate);
    }
  });

  // mutations
  const clearAll = () => store.commit('addFamily/CLEAR_ALL');
  const setAddFamilyContext = (selected) => store.commit('addFamily/SET_ADD_FAMILY_CONTEXT', selected); 
  const setAddSubscriberTransaction = (addSubscriberTransaction) => store.commit('addFamily/SET_ADD_SUBSCRIBER_TRANSACTION', addSubscriberTransaction);
  const setGroupCk = (groupCk) => store.commit('addFamily/SET_GROUP_CK', groupCk); 
  const setGroupName = (groupName) => store.commit('addFamily/SET_GROUP_NAME', groupName); 
  const setHealthIdMatch = (healthIdMatch) => store.commit('addFamily/SET_HEALTH_ID_MATCH', healthIdMatch);
  const setMemberCk = (memberCk) => store.commit('addFamily/SET_MEMBER_CK', memberCk); 
  const setSimilarMembers = (members) => store.commit('addFamily/SET_SIMILAR_MEMBERS', members); 
  const setSsnMatch = (ssnMatch) => store.commit('SET_SSN_MATCH', ssnMatch);
  const setSubGroupCk = (subGroupCk) => store.commit('addFamily/SET_SUB_GROUP_CK', subGroupCk); 
  const setSubscriberCk = (subscriberCk) => store.commit('addFamily/SET_SUBSCRIBER_CK', subscriberCk); 
  const setSubscriberId = (subscriberId) => store.commit('addFamily/SET_SUBSCRIBER_ID', subscriberId); 

  // actions
  // note: the CLEAR_ALL is also defined as an action so it can be called form other actions
  const clearAllAsync = () => store.dispatch('CLEAR_ALL');
  const loadAddSubscriberTransaction = (transaction) => store.dispatch('LOAD_ADD_SUBSCRIBER_TRANSACTION', transaction);

  return {
    classId,
    clearAll,
    clearAllAsync,
    clientId,
    contactInformation,
    dob,
    effectiveDate,
    eyemedId,
    fileBoundId,
    firstName,
    fullName,
    gender,
    groupCk,
    groupId,
    groupName,
    healthIdMatch,
    languageAssistance,
    lastName,
    loadAddSubscriberTransaction,
    memberCk,
    middleInitial,
    planId,
    privacyAddress,
    reportingCodes,
    setAddFamilyContext,
    setAddSubscriberTransaction,
    setGroupCk,
    setGroupName,
    setHealthIdMatch,
    setMemberCk,
    setSimilarMembers,
    setSsnMatch,
    setSubGroupCk,
    setSubscriberCk,
    setSubscriberId,
    similarMembers,
    ssn,
    ssnMatch,
    subGroupCk,
    subGroupId,
    subGroupName,
    subscriberCk,
    subscriberId,
    suffix,
    termDate,
    transaction,
  }

}